import { z } from 'zod';
// URL-friendly code validation - only allows lowercase letters, numbers, and hyphens
const urlFriendlyCodeSchema = z
    .string()
    .min(1, 'Code is required')
    .max(100, 'Code must be less than 100 characters')
    .regex(/^[a-z0-9-]+$/, 'Code must only contain lowercase letters, numbers, and hyphens')
    .refine((code) => !code.startsWith('-') && !code.endsWith('-'), {
    message: 'Code cannot start or end with a hyphen',
})
    .refine((code) => !code.includes('--'), {
    message: 'Code cannot contain consecutive hyphens',
});
const nameSchema = z
    .string()
    .min(1, 'Name is required')
    .max(255, 'Name must be less than 255 characters');
const descriptionSchema = z
    .string()
    .max(1000, 'Description must be less than 1000 characters')
    .nullable()
    .optional();
const locationIdSchema = z.number().int().nullish();
// User-editable fields only (for frontend forms)
export const mediaEncoderCreateSchema = z.object({
    name: nameSchema,
    code: urlFriendlyCodeSchema,
    description: descriptionSchema,
    locationId: locationIdSchema,
});
// Update validation schema (all user-editable fields optional)
export const mediaEncoderUpdateSchema = z.object({
    name: nameSchema.optional(),
    code: urlFriendlyCodeSchema.optional(),
    description: descriptionSchema,
    locationId: locationIdSchema,
});
